import {UI} from "../../stem-core/ui/UIBase";
import {DashboardTablePage} from "../common/DashboardTablePage";
import {apiMerchantDeleteReport, MerchantReport} from "../../client/state/merchant/MerchantReportStore";
import {Messages} from "../../blinkpay/Messages";
import {autoredraw} from "../../stem-core/decorators/AutoRedraw";
import {CENTER_COLUMN, LEFT_COLUMN} from "../common/theme/TableStyle";
import {bytesToSize} from "../../blinkpay/Utils";
import {ReportDownloadButton} from "../common/modals/MerchantReportProgressModal";
import {TrashCanIcon} from "../SVGElements";
import type {EndpointPaginator} from "../../stem-core/state/pagination/EndpointPaginator";
import type {ColumnTuple} from "../../stem-core/base/ColumnHandler";


interface ReportActionOptionsOptions {
    paginator?: EndpointPaginator<any>;
    report?: MerchantReport;
}

class ReportActionOptions extends UI.Element<ReportActionOptionsOptions> {
    async deleteReport() {
        const {report, paginator} = this.options;
        await apiMerchantDeleteReport(report.id);
        paginator.fetchPage()
    }

    render() {
        const {report} = this.options;

        return [
            <ReportDownloadButton report={report} />,
            // TODO: we probably want an IconButton class, with some consistent style
            <TrashCanIcon style={{cursor: "pointer", verticalAlign: "middle"}} size={24} onClick={() => this.deleteReport()} />
        ];
    }
}

@autoredraw(MerchantReport)
export class MerchantReportsPage extends DashboardTablePage<MerchantReport> {
    getDefaultOptions() {
        return {
            title: Messages.reports,
            description: Messages.reportsPageDescription,
            store: MerchantReport,
            endpoint: "/merchant/get_reports",
        }
    }

    getFilters(): null {
        return null;
    }

    getColumns(): ColumnTuple<MerchantReport>[] {
        return [
            ["Id", report => report.id, LEFT_COLUMN],
            ["Type", report => report.type, LEFT_COLUMN],
            ["Created At", report => report.createdAt, CENTER_COLUMN],

            ["File Size", report => bytesToSize(report.fileSize), CENTER_COLUMN],
            ["", report => <ReportActionOptions report={report} paginator={this.getPaginator()}/>, CENTER_COLUMN],
        ]
    }

    onMount() {
        super.onMount();
        // This needs to happen if a new object gets created actually always
        this.attachListener(MerchantReport, "newOwnObject", () => this.paginator.fetchFirstPage());
    }
}
